export const CUSTOM_MESSAGE = {
    SUCCESS_MSG_SHORT: "Success",
    SUCCESS_MSG_LONG_SAVE: "Data Saved Successfully.",
    SUCCESS_MSG_LONG_UPDATE: "Data Updated Successfully.",
    SUCCESS_MSG_LONG_SUBMIT: "Data Submitted Successfully.",
    ERROR_CONNECTION_MSG: "Please check your connection !!!",
}